var agency = {
    text1:"WELCOME TO AGENCY REGISTRATION",
    text2:"Register your agency to continue in the program.",
    text3:"Need to register an agent instead? Click here.",
    successTitle: "Agency registered successfully",
    successText: "The agency was created successfully. From this flow there is no agency admin panel to continue with. If you want to move forward now, you can register an agent for this agency.",
    successPrimaryAction: "Register an agent",
    successSecondaryAction: "Register another agency",
    create: {
      buttonText: "Register agency",
      title: "Register agency",
      agencyNameRequired: "Agency name is required.",
      addressRequired: "Address is required.",
      primaryPhoneRequired: "Primary phone is required.",
      cityRequired: "City is required.",
      contactNameRequired: "Contact first name is required.",
      contactLastNameRequired: "Contact last name is required.",
      emailRequired: "Email is required.",
      passwordRequired: "Password is required.",
      passwordMismatch: "Passwords do not match.",
      termsRequired: "You must accept the terms.",
      countryRequired: "Country is required.",
      stateRequired: "State is required.",
      countryLoadError: "Countries could not be loaded.",
      stateLoadError: "States could not be loaded.",
      submitError: "The agency could not be created.",
      agencyNameLabel: "Agency name",
      agencyNamePlaceholder: "Ex. Sun Travel Agency",
      agencyTypeLabel: "Agency type",
      primaryPhoneLabel: "Primary phone",
      secondaryPhoneLabel: "Secondary phone",
      addressLabel: "Address",
      addressPlaceholder: "Enter the address",
      address2Label: "Address 2",
      agencySectionLabel: "Agency details",
      agencySectionHelp: "Start with the main information of the agency.",
      contactSectionLabel: "Primary contact",
      contactSectionHelp: "Add the main person we should contact for this agency.",
      locationSectionLabel: "Location",
      locationSectionHelp: "Tell us where the agency is located.",
      accessSectionLabel: "Access",
      accessSectionHelp: "Create the access password for this agency.",
      cityLabel: "City",
      zipCodeLabel: "Zip code",
      stateLabel: "State",
      stateIdLabel: "State ID",
      countryLabel: "Country",
      countryIdLabel: "Country ID",
      selectCountryLabel: "Select a country",
      selectStateLabel: "Select a state",
      selectCountryFirstLabel: "Select a country first",
      loadingCountriesLabel: "Loading countries...",
      loadingStatesLabel: "Loading states...",
      contactNameLabel: "Contact first name",
      contactLastNameLabel: "Contact last name",
      contactTitleLabel: "Job title",
      emailLabel: "Email",
      passwordLabel: "Password",
      confirmPasswordLabel: "Confirm password",
      mobileAppNameLabel: "Mobile App Name",
      registrationTypeLabel: "Registration Type",
      marivalRewardsLabel: "Marival Rewards",
      branchAgencyLabel: "Is branch agency",
      hasHqLabel: "Has HQ",
      termsTextBefore: "I have read and accept the terms and conditions for the use of ",
      termsLinkText: "Marival Resorts’ multimedia materials",
      termsTextAfter: ".",
      policiesRequired: "You must accept the Privacy Notice and Cookie Policy.",
      policiesTextBefore: "I have read and accept the terms of the ",
      policiesPrivacyLink: "Privacy Notice",
      policiesTextMiddle: " and ",
      policiesCookieLink: "Cookie Policy",
      policiesTextAfter: ".",
      cancelButton: "Cancel",
      submittingButton: "Creating...",
      submitButton: "Save / Create agency"
    }
    
}
module.exports = agency
